import React from 'react'
import "./Portfolio.css"
import Project from "./Project.js"
import { Button } from "@material-ui/core"
import AirBnb from "./AirBnb.png"
import Spotify from "./Spotify.png"
import Whatsapp from "./What'sAppWeb.png"
import Covid from "./Covid-19.png"
import weatherApp from "./DjangoWeather.png"
import ecom from "./ecom.png"
function Portfolio() {
    return (
        <div className="portfolio">
            <div className="top">
                <h4>Technologies :</h4>
                <Button variant="outlined"> React</Button>
                <Button variant="outlined"> Context API</Button>
                <Button variant="outlined"> Redux</Button>
                <Button variant="outlined"> Django</Button>
                <Button variant="outlined"> Sql</Button>
                <Button variant="outlined"> SqlLite</Button>
                <Button variant="outlined"> Bootstrap</Button>
                <Button variant="outlined"> Material-ui</Button>
            </div>
            <center>React Project's</center>
            <div className="project_results">
                <Project
                    img={AirBnb}
                    title="Airbnb Clone"
                    description="A complete clone of the airbnb website with react.
                                 Features -: a)Date Selection
                                             b) Search for nearby hotels "
                />
                <Project
                    img={Spotify}
                    title="Spotify Clone"
                    description="A complete clone of the spotify web application with react.
                                 Features -: a)Login (Using Spotify for developers)
                                             b)Getting user playlists
                                             c)Bringing in songs from the specific user playlists"
                />
                <Project
                    img={Whatsapp}
                    title="Whats'App Clone"
                    description="A complete clone of the whatsApp  web application with react.
                                 Features -: a)Login (Using Gmail [with help of firebase] for developers)
                                             b)Adding new chat
                                             c)Sending and recieveing messages
                                             d)Last seen based on the last sent message in the chat"
                />
                <Project
                    img={Covid}
                    title="Covid-19 Traker"
                    description="A covid-19 tracker web app that let you select a country and get the number of new, recovered, and deaths in the last 24 hour's.
                                 Features -: a)Map with red circle's on the country selected describing the effect of the pandemic on the country.
                                             b)A table that tells you the number of cases in each country in decreasing oder of their total number of cases."
                />
                <center>Django Project's</center>
                <Project
                    img={weatherApp}
                    title="Weather Check"
                    description="A weather web app that let you select a city and get the weather situation of that city (temprature,Sky details)
                                 Features -: a)Add any city according to your convienience
                                             b)Login into your personal weather check account(used django authentication)
                                             c)Contact us for any queries"
                />
                <Project
                    img={ecom}
                    title="My Awesome Cart"
                    description="A e-commerce web app that let you purchase goods online.
                                 Features -: a)Add items to cart
                                             b)place oder ang get an oder receipt of your oder
                                             c)Track your oder
                                             d)Contact us for any queries"
                />
            </div>
        </div>
    )
}

export default Portfolio
